import { useState, useEffect } from "react";
import { api } from "@/lib/api";

export default function useAlgorithms() {
  const [algorithms, setAlgorithms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/algorithms");
        if (!cancelled) setAlgorithms(res.data?.algorithms || res.data || []);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { algorithms, loading, error };
}
